var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-condition',{staticStyle:{"margin-bottom":"30px"}}),_c('select-result')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }